const Loading = (ctx) => (
  <div
    {
      ...{
        ...ctx.data,
        staticStyle: {
          overflow: 'auto',
          ...ctx.data.staticStyle
        },
      }
    }
  >
    {ctx.slots().default}
  </div>
);

export default () => ({
  component: (async () => {
    // TODO prefetch and preload?
    const componentP = import('simplebar-vue');
    const styleP = import('simplebar/dist/simplebar.min.css');
    await styleP;
    return await componentP;
  })(),
  loading: Loading,
});
